import { create } from "zustand";

// Whether the Creators-tab metric cards row (tabs/AnalyticsBar.tsx) is shown.
// Toggled by the chevron left of the campaign tabs (CampaignPage.tsx) and
// persisted so the choice sticks across campaigns/sessions.
const STORAGE_KEY = "show_analytics_bar";

interface AnalyticsBarStore {
  showAnalyticsBar: boolean;
  toggleAnalyticsBar: () => void;
}

export const useAnalyticsBarStore = create<AnalyticsBarStore>((set) => ({
  showAnalyticsBar: localStorage.getItem(STORAGE_KEY) !== "false",
  toggleAnalyticsBar: () =>
    set((state) => {
      const next = !state.showAnalyticsBar;
      localStorage.setItem(STORAGE_KEY, String(next));
      return { showAnalyticsBar: next };
    }),
}));
